import 'jquery';

const getScrollbarWidth = function () {
  try {
    const outer = document.createElement('div');
    outer.style.visibility = 'hidden';
    outer.style.width = '100px';
    outer.style.msOverflowStyle = 'scrollbar';
    document.body.appendChild(outer);
    const widthNoScroll = outer.offsetWidth;
    outer.style.overflow = 'scroll';
    const inner = document.createElement('div');
    inner.style.width = '100%';
    outer.appendChild(inner);
    const widthWithScroll = inner.offsetWidth;
    outer.parentNode.removeChild(outer);
    return widthNoScroll - widthWithScroll;
  } catch (err) {
    return null;
  }
};

const Variables = (() => ({
  scrollbarWidth: 0,
  breakpoints: {
    desktop: 768,
    handheld: 568,
  },
  initialize: () => {
    const scrollbarWidth = getScrollbarWidth();
    if (scrollbarWidth != null) {
      Variables.scrollbarWidth = scrollbarWidth;
    }
  },
}))();

export default Variables;



// WEBPACK FOOTER //
// ./scripts/App/Variables.js